import * as Yup from "yup";
import {
  createPleaseEnterValueBetweenDollarAmount,
  digitPhoneInputFieldRegex,
  dobAgeMessage,
  emailInputFieldRegex,
  emailInputFieldRegexMessage,
  invalidValue,
  isDobFieldValid,
  requiredDigitInputFieldRegex,
  requiredLetterInputFieldRegex,
  requiredLetterInputFieldRegexMessage,
  requiredPhoneInputFieldRegexMessage,
  twoCharacterInputFieldRegex,
  loanAmountRequiredMessage,
  requestedProductTypeRequiredMessage,
  loanReasonRequiredMessage,
  firstNameRequiredMessage,
  lastNameRequiredMessage,
  mobilePhoneRequiredMessage,
  emailAddressRequiredMessage,
  birthDayRequiredMessage,
  birthMonthRequiredMessage,
  birthYearRequiredMessage,
  titleRequiredMessage,
} from "./shared";

function createLoanAmountTester() {
  return {
    is: () => true,
    then: () =>
        Yup.string()
            .trim()
            .test({
              name: "loan-amount-range",
              test: (value, testContext) => {
                const { context, parent } = testContext.options;
                const productList = context.allLoanTypes  || [];
                const { requestedProductType } = parent;

                const selectedProduct = productList.find(
                    (product) => product.type === requestedProductType
                );

                if (!selectedProduct) {
                  return true;
                }

                const numeric = parseInt(value);
                let isValid = numeric >= selectedProduct.from && numeric <= selectedProduct.to;
                
                // Returns true when the loan amount is valid or returns a Yup ValidationError when it isn't.
                // It's expected behaviour to return different types - but unfortunately, Sonar doesn't seem to agree!
                return isValid || testContext.createError({
                  message: createPleaseEnterValueBetweenDollarAmount(selectedProduct.from, selectedProduct.to)
                });
              }
            })
  };
}

export const startSchema = Yup.object({
  title: Yup.string().trim().required(titleRequiredMessage),
  loanAmount: Yup.string()
      .when("requestedProductType", createLoanAmountTester())
      .required(loanAmountRequiredMessage),
  requestedProductType: Yup.string().trim().required(requestedProductTypeRequiredMessage),
  loanReason: Yup.string().trim().required(loanReasonRequiredMessage),
  firstName: Yup.string()
    .trim()
    .matches(requiredLetterInputFieldRegex, {
      message: invalidValue,
      excludeEmptyString: true,
    })
    .matches(twoCharacterInputFieldRegex, {
      message: requiredLetterInputFieldRegexMessage,
      excludeEmptyString: true,
    })
    .required(firstNameRequiredMessage),
  lastName: Yup.string()
    .trim()
    .matches(requiredLetterInputFieldRegex, {
      message: invalidValue,
      excludeEmptyString: true,
    })
    .matches(twoCharacterInputFieldRegex, {
      message: requiredLetterInputFieldRegexMessage,
      excludeEmptyString: true,
    })
    .required(lastNameRequiredMessage),
  mobilePhone: Yup.string()
    .required(mobilePhoneRequiredMessage)
    .matches(requiredDigitInputFieldRegex, {
      message: invalidValue,
      excludeEmptyString: true,
    })
    .test("test-number", requiredPhoneInputFieldRegexMessage(), (value) => {
      return digitPhoneInputFieldRegex.test(value);
    }),
  emailAddress: Yup.string()
    .required(emailAddressRequiredMessage)
    .test("test-name", emailInputFieldRegexMessage, (value) => {
      return emailInputFieldRegex.test(value);
    }),
  dateOfBirth: Yup.object()
    .test("dateOfBirth", dobAgeMessage, (value) => {
      return (
        value &&
        value.day &&
        value.month &&
        value.year &&
        isDobFieldValid(value)
      );
    })
    .shape({
      day: Yup.string().trim().required(birthDayRequiredMessage),
      month: Yup.string().trim().required(birthMonthRequiredMessage),
      year: Yup.string().trim().required(birthYearRequiredMessage),
    }),
});
